module.exports = __webpack_public_path__ + "img/second_appointment_text3.b4fd986a.jpg";